import * as React from "react";

import "./account-line.scss";

import {cs}         from "@Common/react/chain-services";
import {upperCase1} from "@Common/utils/strings";

import {ConfirmationModal} from "./confirmation-modal";

export const AccountLine = ({onRemoveAccount, account, type}) => cs(
    ["confirmModal", (_, next) => ConfirmationModal({
        confirmRemoval: onRemoveAccount,
        next,
    })],
    ({confirmModal}) => (
        <div className="account-line-6dj">

            <div
                className="account"
            >
                <img
                    src={account.picture} alt=""
                    xd-qa-type="image" xd-qa-name={"Account " + account.name}
                />

                <div
                    className="name"
                    xd-qa-type="label" xd-qa-name={"Account " + account.name}
                >
                    {account.name}
                </div>
            </div>

            <div className="controls">
                <a
                    className="remove" onClick={confirmModal.show}
                    xd-qa-type="link"
                    xd-qa-name={"Remove " + upperCase1(type) + " Account " + account.name}
                >
                    Remove
                </a>

                {account.edit && (
                    <a
                        className="edit"
                        onClick={() => account.edit()}
                        xd-qa-type="link"
                        xd-qa-name={"Edit " + account.name}
                    >
                        Edit
                    </a>
                )}
            </div>

        </div>
    ),
);
